export const FacturasIngresadaDTO = (formData:any,presentacion:number ) =>({
    Fac_id: 0,
    Red_id: 0,
    PreCupon: presentacion,
    Fac_sucursal : parseInt(formData.Fac_sucursal),
    Fac_numero : formData.Fac_numero,
    Fac_fecha: formData.Fecha,
    Fat_id: formData.fat_descripcion_red.fat_id,
    Fat_descripcion_red: "",
    Fac_neto:parseFloat(formData.Fac_neto),
    Fac_impuestos:parseFloat(formData.Fac_impuestos),
    Fac_iva : parseFloat(formData.Fac_iva),
    Fac_iva_percepcion:formData.Fac_iva_percepcion ? parseFloat(formData.Fac_iva_percepcion) : 0,
    Fac_IIBB_percepcion: formData.Fac_IIBB_percepcion ? parseFloat(formData.Fac_IIBB_percepcion) : 0,
    Fac_tipo_comprobante: formData.fac_tipo_comprobante,//"A"
    Fac_total:parseFloat(formData.Fac_total),
    Fac_nro_cai: "",
    Fac_vencimiento_cai: new Date(),
    Fac_controlador_fiscal: false,
    Fac_tasa_iva: parseFloat(formData.Fac_tasa_iva.tasa),
    Fac_diferencia:0.0,
    Fac_registracion : new Date(),
    Fac_orig:false,
    Descripcion:"",
    Fac_redondeo: 0.0,
    Fac_electronica:false,
    Fpa_nombre_imagen: "",
    TipoInscripcion:{},
    
})

export const FacturasIngresadaDTODelete = (rowData:any) =>({
    Fac_id: rowData.fac_id,
    Red_id: 0,
    PreCupon: 0,
    Fac_sucursal : 0,
    Fac_numero : "",
    Fac_fecha: new Date(),
    Fat_id: 0,
    Fat_descripcion_red: "",
    Fac_neto: 0,
    Fac_impuestos:0,
    Fac_iva : 0,
    Fac_iva_percepcion:0,
    Fac_IIBB_percepcion: 0,
    Fac_tipo_comprobante: "",
    Fac_total:0,
    Fac_nro_cai: "",
    Fac_vencimiento_cai: new Date(),
    Fac_controlador_fiscal: false,
    Fac_tasa_iva: 0,
    Fac_diferencia: 0,
    Fac_registracion : new Date(),
    Fac_orig:false,
    Descripcion:"",
    Fac_redondeo: 0.0,
    Fac_electronica:false,
    fpa_nombre_imagen:rowData.fpa_nombre_imagen,
    TipoInscripcion:{}
})
export const FacturasIngresadaOCRDTO = (formData:any,presentacion:number,ocr:any ) =>({
    Fac_id: 0,
    Red_id: 0,
    PreCupon: presentacion,
    Fac_sucursal : parseInt(formData.Fac_sucursal),
    Fac_numero : formData.Fac_numero,
    Fac_fecha: formData.Fecha,
    Fat_id: formData.fat_descripcion_red.fat_id,
    Fat_descripcion_red: "",
    Fac_neto:parseFloat(formData.Fac_neto),
    Fac_impuestos:parseFloat(formData.Fac_impuestos),
    Fac_iva : parseFloat(formData.Fac_iva),
    Fac_iva_percepcion:formData.Fac_iva_percepcion ? parseFloat(formData.Fac_iva_percepcion) : 0,
    Fac_IIBB_percepcion: formData.Fac_IIBB_percepcion ? parseFloat(formData.Fac_IIBB_percepcion) : 0,
    Fac_tipo_comprobante: formData.fac_tipo_comprobante,//"A"
    Fac_total:parseFloat(formData.Fac_total),
    Fac_nro_cai: "",
    Fac_vencimiento_cai: new Date(),
    Fac_controlador_fiscal: false,
    Fac_tasa_iva: parseFloat(formData.Fac_tasa_iva.tasa),
    Fac_diferencia:0.0,
    Fac_registracion : new Date(),
    Fac_orig:false,
    Descripcion:"",
    Fac_redondeo: 0.0,
    Fac_electronica:false,
    Fpa_nombre_imagen: "",
    TipoInscripcion:{},
    Fac_document_data_Id_OCR:ocr.documentID,
    Fac_ingreso_manual:ocr.ingresoManual,
    Fac_observaciones_OCR:ocr.observaciones,
})